<template>
  <div class="result">
    <h1>{{jage}}</h1>
    <nav class="level has-text-centered" style>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">勝利</p>
          <p class="title">{{win}}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">引き分け</p>
          <p class="title">{{drow}}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">敗北</p>
          <p class="title">{{lose}}</p>
        </div>
      </div>
    </nav>

    <!-- <div v-for="i of jankenHistory.p_history.length" :key="i">
      <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="title">{{jan[jankenHistory.p_history[i-1]]}}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="title">{{(i) + "戦目"}}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="title">{{jan[jankenHistory.e_history[i-1]]}}</p>
          </div>
        </div>
      </nav>
    </div>-->
  </div>
</template>

<script>
const apiUrl =
  process.env.VUE_APP_DB_API;
const config = {
  headers: {
    "Content-Type": "application/json"
  }
};
import axios from "axios";
import { constants } from "crypto";
import { mapState } from "vuex";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python.js";
import "codemirror/theme/mbo.css";
import "codemirror/addon/selection/active-line.js";
// closebrackets
import "codemirror/addon/edit/closebrackets.js";

import anime from "animejs";

export default {
  name: "Practice",
  data() {
    return {
      win: 0,
      lose: 0,
      drow: 0,
      jan: { 0: "✊", 1: "✌️", 2: "🖐" }
    };
  },
  components: {
    anime
  },
  watch: {
    jankenHistory(j) {
      this.win = this.lose = this.drow = 0;
      this.setWin(j.win, this.win);
      this.setLose(j.lose, this.lose);
      this.setDrow(j.drow, this.drow);
    }
  },
  mounted: function() {
    this.jankenHistory = { win: 0, lose: 0, drow: 0 };
  },
  computed: {
    jankenHistory: {
      get() {
        return this.$store.state.jankenHistory;
      },
      set(h) {
        this.$store.commit("setJankenHistory", h);
      }
    },
    jage: {
      get() {
        if (this.jankenHistory.win > this.jankenHistory.lose) return "勝利";
        if (this.jankenHistory.lose > this.jankenHistory.win) return "敗北";
        if ((this.jankenHistory.drow = this.jankenHistory.drow))
          return "引き分け";
        return "";
      }
    }
  },
  methods: {
    setWin(val) {
      const obj = { n: this.win };
      anime({
        targets: obj,
        n: val,
        round: 1,
        duration: 500,
        easing: "linear",
        update: () => {
          this.win = obj.n;
        }
      });
    },
    setDrow(val) {
      const obj = { n: this.drow };
      anime({
        targets: obj,
        n: val,
        round: 1,
        duration: 500,
        easing: "linear",
        update: () => {
          this.drow = obj.n;
        }
      });
    },
    setLose(val) {
      const obj = { n: this.lose };
      anime({
        targets: obj,
        n: val,
        round: 1,
        duration: 500,
        easing: "linear",
        update: () => {
          this.lose = obj.n;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.result {
}
h1 {
  margin-top: 20px;
  font-size: 30px;
  text-align: center;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
